import Vuex from 'vuex';
import Vue from 'vue';

import { SET_APP_CONFIG, SET_LANGUAGES, SET_LEVELS, SET_CHARGING } from '@/store/mutations.js';

// import app from "@/js/app.js";
import notify from '@/js/helpers/notify.js';
import modules from '@/store/modules/index.js';
import apiRequest from '@/js/helpers/apiRequest.js';

Vue.use(Vuex);

export default new Vuex.Store({
  modules,

  state: {
    appConfig: {},
    languages: [],
    currentLangId: 1,
    levels: [],
    // categories: [],
    // wordsByCategory: [],
    // descriptionLoading: false,
    charging: 0
  },

  mutations: {
    [SET_APP_CONFIG]: (state, appConfig) => {
      state.appConfig = appConfig;
    },

    [SET_LANGUAGES]: (state, languages) => {
      state.languages = languages;
    },

    [SET_LEVELS]: (state, levels) => {
      state.levels = levels;
    },

    // [SET_CATEGORIES]: (state, { categories }) => {
    //   state.categories = categories;
    // },

    // [SET_WORDS_CATEGORIES]: (state, { categoryId, words = [] }) => {
    //   state.wordsByCategory.push({
    //     categoryId,
    //     words
    //   });
    // },

    // [SET_WORDS_DESCRIPTION]: (state, { description, word, categoryId }) => {
    //   const { words } = state.wordsByCategory.find(
    //     category => category.categoryId === categoryId
    //   );

    //   if (words.length) {
    //     const currentWords = words.filter(item => item.name === word);

    //     for (let item of currentWords) {
    //       item.description = description;
    //     }
    //   }
    // },

    // [SET_LOADING_DESCRIPTION]: (state, payload) => {
    //   state.descriptionLoading = payload;
    // },

    [SET_CHARGING]: (state, charging) => {
      state.charging = charging;
    }
  },

  actions: {
    getLanguages: async ({ commit }) => {
      try {
        const res = await apiRequest('languages', 'GET', null, true);

        if (res.error) {
          throw { customeError: res.error };
        }

        commit(
          SET_LANGUAGES,
          res.success.languages.map(({ id, name }) => ({ id, name }))
        );
      } catch (error) {
        if (res.customeError) {
          notify({ text: res.customeError });
        } else {
          console.error('ERROR: languages');
        }
      }
    },

    getLevels: async ({ commit }) => {
      try {
        const res = await apiRequest('levels', 'GET', null, true);

        if (res.error) {
          throw { customeError: res.error };
        }

        commit(SET_CHARGING, res.success.charging);
        commit(
          SET_LEVELS,
          res.success.levels.map(({ id, name, price, image }) => ({
            id,
            name,
            price,
            image
          }))
        );
      } catch (error) {
        if (error.customeError) {
          notify({ text: error.customeError });
        } else {
          console.error('ERROR: levels');
        }
      }
    },

    getAppConfig: async ({ commit }) => {
      try {
        const res = await apiRequest('config', 'GET', null);

        if (res.error) {
          throw { customeError: res.error };
        }

        commit(SET_APP_CONFIG, res.success);
      } catch (error) {
        if (error.customeError) {
          notify({ text: error.customeError });
        } else {
          console.error('ERROR: config:', error);
        }
      }
    }

    // getWordsCategories: async ({ commit }, id = "") => {
    //   try {
    //     const res = await apiRequest(
    //       `words/categories/${1}${id.length ? `/${id}` : ""}`,
    //       "GET",
    //       null,
    //       true
    //     );

    //     if (res.error) {
    //       throw { customeError: res.error };
    //     }

    //     commit(SET_CATEGORIES, { categories: res.success });
    //   } catch (error) {
    //     if (error.customeError) {
    //       notify({ text: error.customeError });
    //     } else {
    //       console.error("ERROR: languages");
    //     }
    //   }
    // },

    // getWordsByCategory: async ({ state, commit }, { id }) => {
    //   if (
    //     !state.wordsByCategory.filter(item => item.categoryId === id).length
    //   ) {
    //     const res = await apiRequest(`words/${id}`, "GET", null, true);

    //     if (res.error) {
    //       throw { customeError: res.error };
    //     }

    //     const words = res.success.map(word => ({
    //       ...word,
    //       description: {
    //         definition: "",
    //         pronunciation: "",
    //         examples: "",
    //         synonyms: []
    //       }
    //     }));

    //     commit(SET_WORDS_CATEGORIES, { categoryId: id, words });
    //   }
    // },

    // getWordDescription: async ({ state, commit }, { word, categoryId }) => {
    //   // Если есть описание для слова в сторе то не грузим повторно
    //   const { words } = state.wordsByCategory.find(
    //     category => category.categoryId === categoryId
    //   );

    //   if (words.length) {
    //     const definition = words.find(item => item.name === word).description
    //       .definition;

    //     if (definition.length) {
    //       return;
    //     }
    //   }

    //   commit(SET_LOADING_DESCRIPTION, true);
    //   const body = new FormData();
    //   body.append("word", word);

    //   const res = await apiRequest(`word`, "POST", body, true);

    //   commit(SET_LOADING_DESCRIPTION, false);

    //   if (res.error) {
    //     throw { customeError: res.error };
    //   }

    //   if (res.success.results.length) {
    //     const {
    //       pronunciation: { all: pronunciation }
    //     } = res.success;
    //     const { definition, examples, synonyms } = res.success.results[0];

    //     commit(SET_WORDS_DESCRIPTION, {
    //       description: {
    //         pronunciation,
    //         examples: examples && examples.length ? examples[0] : "",
    //         synonyms,
    //         definition
    //       },
    //       word,
    //       categoryId
    //     });
    //   }
    // }
  }
});
